declare const jQuery: any;
const $ = jQuery;

//const onLargeScreen: () => boolean = window["iw"].breakpoints.onLargeScreen;
const registerScrollDetectEvent: Function = window["iw"].registerScrollDetectEvent;

let onTouchScreen = false;
$("body").one("touchstart", function (e) {
	onTouchScreen = true;
});

export function initLogoGrid(): void
{
	const $wraps = $(".logo-grid");
	if ($wraps.length === 0)
	{
		return;
	}
	const $window = $(window);
	const togglePopup = function togglePopup($item) {
		const alreadyOpen: boolean = $item.hasClass("open");
		$wraps.find(".logo-grid-item").removeClass("open");
		if (!alreadyOpen)
		{
			$item.addClass("open");
		}
	};
	const showPopup = function showPopup($item) {
		$wraps.find(".logo-grid-item").removeClass("open");
		$item.addClass("open");
	};
	const hidePopup = function hidePopup($item) {
		$item.removeClass("open");
	};
	$wraps.each(function () {
		const $wrap = $(this);
		const $items = $wrap.find(".logo-grid-item.has-popup");
		$items.on("click", function (ev) {
			ev.stopPropagation();
			const $item = $(this);
			if (onTouchScreen)
			{
				showPopup($item);
			}
			return false;
		}).on("mouseenter", function (ev) {
			if (!onTouchScreen)
			{
				showPopup($(this));
			}
		}).on("mouseleave", function (ev) {
			if (!onTouchScreen)
			{
				hidePopup($(this));
			}
		});
		registerScrollDetectEvent(() => {
			$wrap.addClass("scrolled");
		}, () => {
			$wrap.removeClass("scrolled");
		}, () => {
			const viewportHeight: number = $window.outerHeight();
			const divTop: number = $wrap.offset().top;
			return (divTop - viewportHeight);
		})
	});
}
